import { useMemo } from "react";

import dayjs from "dayjs";

import { shortMonthAndYear } from "@similarweb/pro-logic-components";

import { getCountryText } from "./getCountryText";
import type { ISubtitleFilter } from "./types";

interface ISubtitleFilterParams {
    countryCode: number;
    countryText: string;
    dateRangeText: string;
}

export const useSubtitleFilterParams = (subtitleFilters: unknown): ISubtitleFilterParams => {
    const safeSubtitleFilters: ISubtitleFilter[] = Array.isArray(subtitleFilters)
        ? (subtitleFilters as ISubtitleFilter[])
        : [];

    return useMemo(() => {
        const countryFilter = safeSubtitleFilters.find((item) => item?.filter === "country");
        const dateFilter = safeSubtitleFilters.find((item) => item?.filter === "date");

        const dateValue =
            typeof dateFilter?.value === "object" && dateFilter.value
                ? (dateFilter.value as { from?: number; to?: number })
                : undefined;

        const countryCode = Number(countryFilter?.countryCode) || 0;
        const countryText = getCountryText(countryCode);

        const dateRangeText =
            dateValue?.from && dateValue?.to
                ? `${dayjs(dateValue.from).format(shortMonthAndYear)} - ${dayjs(dateValue.to).format(shortMonthAndYear)}`
                : "N/A";

        return { countryCode, countryText, dateRangeText };
    }, [safeSubtitleFilters]);
};
